import { __assign, __read, __spreadArray, __values } from "tslib";
import { FormFieldValidator } from "Login/FormFieldValidationMapper";
import { FormError, Validation } from "Login/Decorator/Validator";
import { expandObjectParameters, flattenObjectStructure } from "Login/Utils/ObjectTransformation";
import { Executor } from "Login/Decorator/Executor";
var FormHelper = /** @class */ (function () {
    function FormHelper() {
        this._formName = '';
    }
    Object.defineProperty(FormHelper, "instance", {
        get: function () {
            if (!this._instance) {
                this._instance = new FormHelper();
            }
            return this._instance;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormHelper.prototype, "formFieldValidator", {
        get: function () {
            return this._formFieldValidator;
        },
        enumerable: false,
        configurable: true
    });
    FormHelper.prototype.reset = function () {
        this._formFieldValidator.reset();
        this.form.reset();
    };
    FormHelper.prototype.setCurrentForm = function (formName) {
        this._formName = formName;
        this._formFieldValidator = new FormFieldValidator();
    };
    Object.defineProperty(FormHelper.prototype, "form", {
        get: function () {
            return document.forms[this._formName];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormHelper.prototype, "formElementKeys", {
        get: function () {
            return __spreadArray([], __read(this.form.elements), false).map(function (input) { return input.name; });
        },
        enumerable: false,
        configurable: true
    });
    FormHelper.prototype.mapValue = function (element) {
        switch (element.type) {
            case 'checkbox': return element.checked;
            default: return element.value;
        }
    };
    FormHelper.prototype.preValidate = function (group, requestClass) {
        if (group === void 0) { group = 'validate'; }
        var serializedData = FormHelper.instance.serialize();
        var request = new requestClass();
        request.deserialize(expandObjectParameters(serializedData));
        var validation = Validation.validate(request, group);
        var preValidation = flattenObjectStructure(validation.serialize, [FormError]);
        Executor.execute(request);
        return { data: preValidation, valid: validation.isValid, request: request };
    };
    FormHelper.prototype.serialize = function () {
        var _this = this;
        var serializedData = __spreadArray([], __read(this.form.elements), false).reduce(function (p, c) {
            var _a;
            return __assign(__assign({}, p), (_a = {}, _a[c.name] = _this.mapValue(c), _a));
        }, {});
        Object.keys(serializedData).forEach(function (key) {
            if (!serializedData[key])
                delete serializedData[key];
        });
        return serializedData;
    };
    FormHelper.prototype.showFormError = function (errorMap) {
        var e_1, _a;
        this._formFieldValidator.reset();
        try {
            for (var _b = __values(Object.entries(errorMap)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                this._formFieldValidator.update(key, value);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    return FormHelper;
}());
export default FormHelper;
